import React, { Suspense } from 'react';
import './hero.css';
import { ShaderGradient, ShaderGradientCanvas } from '@shadergradient/react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import GlobalHeader from '../Common/GlobalHeader';

const Hero = () => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  return (
    <section className="hero-section">
      {/* Shader Background - Deepest Layer */}
      <div className="shader-container">
        <Suspense fallback={null}>
          <ShaderGradientCanvas
            style={{ position: "absolute", inset: 0 }}
            pixelDensity={1}
            fov={110}
          >
            <ShaderGradient
              control="props"
              type="sphere"
              animate="on"
              brightness={1}
              cAzimuthAngle={0}
              cDistance={14}
              cPolarAngle={140}
              cameraZoom={4.99}
              color1="#ff0000"
              color2="#ff6000"
              color3="#ffffff"
              envPreset="dawn"
              grain="off"
              lightType="env"
              positionX={0}
              positionY={0}
              positionZ={0}
              range="disabled"
              rangeEnd={40}
              rangeStart={0}
              reflection={0}
              rotationX={0}
              rotationY={0}
              rotationZ={0}
              shader="defaults"
              uAmplitude={0}
              uDensity={10}
              uFrequency={5.5}
              uSpeed={0.1}
              uStrength={1}
              uTime={0}
              wireframe={false}
              zoomOut={true}
            />
          </ShaderGradientCanvas>
        </Suspense>
      </div>

      {/* Connection Arrows (SVG Layer) */}
      <svg className="hero-arrows" viewBox="0 0 100 100" preserveAspectRatio="none">
        {/* Path to Card 1: Top Left */}
        <path d="M 50,50 Q 30,20 15,20" className="arrow-path path-1" />
        {/* Path to Card 2: Bottom Left */}
        <path d="M 50,50 Q 35,75 25,85" className="arrow-path path-2" />
        {/* Path to Card 3: Top Right */}
        <path d="M 50,50 Q 70,25 85,25" className="arrow-path path-3" />
        {/* Path to Card 4: Bottom Right */}
        <path d="M 50,50 Q 80,70 80,80" className="arrow-path path-4" />
      </svg>

      {/* Decorative Blobs */}
      <div className="blob blob-left"></div>
      <div className="blob blob-right"></div>

      {/* Floating Cards - Left Side */}
      <div className="floating-cards floating-left">
        <div
          className="floating-card card-1"
        >
          <div className="card-content">
            <span className="card-label">Automate</span>
            <h4 className="card-title">AI Workflows</h4>
            <p className="card-text">Execute complex multi-agent sequences with zero oversight.</p>
          </div>
        </div>
        <div
          className="floating-card card-2"
        >
          <div className="card-content">
            <span className="card-label">Scale</span>
            <h4 className="card-title">Presence</h4>
            <p className="card-text">Exponential growth on X and Pinterest via viral automation.</p>
          </div>
        </div>
      </div>

      {/* Floating Cards - Right Side */}
      <div className="floating-cards floating-right">
        <div
          className="floating-card card-3"
        >
          <div className="card-content">
            <span className="card-label">Control</span>
            <h4 className="card-title">Private Keys</h4>
            <p className="card-text">Connect your own API keys for total data sovereignty.</p>
          </div>
        </div>
        <div
          className="floating-card card-4"
        >
          <div className="card-content">
            <span className="card-label">Host</span>
            <h4 className="card-title">Own Infra</h4>
            <p className="card-text">Deploy agents on your local hardware or private cloud.</p>
          </div>
        </div>
      </div>

      {/* Navbar - Top Layer */}
      <GlobalHeader />

      {/* Hero Central Content */}
      <div className="hero-container">
        <button
          className="cta-button"
          onClick={() => document.getElementById('pricing').scrollIntoView({ behavior: 'smooth' })}
        >
          Get Your Agent!
        </button>
      </div>
    </section>
  );
};

export default Hero;
